var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.82554 11.8078C7.83304 10.9379 10.8333 8.12121 10.8333 5.41667C10.8333 4.2674 10.3768 3.1652 9.56413 2.35254C8.75147 1.53988 7.64927 1.08333 6.5 1.08333C5.35073 1.08333 4.24853 1.53988 3.43587 2.35254C2.62321 3.1652 2.16667 4.2674 2.16667 5.41667C2.16667 8.12121 5.16696 10.9379 6.17446 11.8078C6.26832 11.8784 6.38257 11.9165 6.5 11.9165C6.61743 11.9165 6.73168 11.8784 6.82554 11.8078Z",
    stroke: "#030F1B",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 7.04167C7.39746 7.04167 8.125 6.31413 8.125 5.41667C8.125 4.5192 7.39746 3.79167 6.5 3.79167C5.60254 3.79167 4.875 4.5192 4.875 5.41667C4.875 6.31413 5.60254 7.04167 6.5 7.04167Z",
    stroke: "#030F1B",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.e1abd22b758fbe69d33777406d1a0b17.svg";
export { ForwardRef as ReactComponent };